import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import { GoDotFill } from "react-icons/go";

const DashboardAdmin = ({ user, data }) => {
  const stats = data?.stats || {};
  const settings = data?.settings;
  const recentWinners = data?.recentWinners || [];
  const wallet = data?.wallet;
  const walletBalance = Number(wallet?.wallet_balance || 0);
  
  const [gameStatus, setGameStatus] = useState({
    game_3min: true,
    game_5min: true,
  });

  useEffect(() => {
    if (
      settings &&
      (settings.game_3min !== undefined || settings.game_5min !== undefined)
    ) {
      setGameStatus((prev) => ({
        ...prev,
        ...(settings.game_3min !== undefined && {
          game_3min: !!settings.game_3min,
        }),
        ...(settings.game_5min !== undefined && {
          game_5min: !!settings.game_5min,
        }),
      }));
    }
  }, [data?.settings]);

  useEffect(() => {
    const s = io(process.env.REACT_APP_NODE_URL, { transports: ["websocket"] });
    s.on("gameStatusChange", (payload) => {
      if (
        payload &&
        (payload.game_3min !== undefined || payload.game_5min !== undefined)
      ) {
        setGameStatus((prev) => ({
          ...prev,
          ...(payload.game_3min !== undefined && {
            game_3min: !!payload.game_3min,
          }),
          ...(payload.game_5min !== undefined && {
            game_5min: !!payload.game_5min,
          }),
        }));
      }
    });
    return () => s.disconnect();
  }, []);

  return (
    <>
      <div className="dashboard-grid">
        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>Wallet Balance</h3>
            <p className="stat-value">₹{walletBalance.toFixed(2)}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-content">
            <h3>Running Sessions</h3>
            <p className="stat-game-value">
              3min{" "}
              <span className={gameStatus.game_3min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_3min ? "Live" : "Stopped"}
              </span>
            </p>
            <p className="stat-game-value">
              5min{" "}
              <span className={gameStatus.game_5min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_5min ? "Live" : "Stopped"}
              </span>
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>Today Sessions</h3>
            <p className="stat-value">{stats.todaySessionsCount ?? 0}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-content">
            <h3>Today Winners</h3>
            <p className="stat-value">{stats.todayWinnersCount ?? 0}</p>
          </div>
        </div>
        {/* <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h3>Total Users</h3>
            <p className="stat-value">{stats.totalUsersCount ?? 0}</p>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default DashboardAdmin;
